//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "GXInfoManage",
};
